import QywxProtocol from './qywx.protocol';
import WxProtocol from './wx.protocol';
import DingTalkProtocol from './dingtalk.protocol';
import FsProtocol from './fs.protocol';
import { EcoType } from '../const/enums';
/**
 * 获取指定生态的接口协议
 * @param {string} key
 * 从 /const/enums EcoType 中定义的类型匹配
 * @returns function
 * 协议调用，统一函数
 */

var protocol = function protocol(key) {
  switch (key) {
    case EcoType.qywx:
      return QywxProtocol;

    case EcoType.wx:
      return WxProtocol;

    case EcoType.dingTalk:
      return DingTalkProtocol;

    case EcoType.fs:
      return FsProtocol;

    default:
      (function () {});

  }
};

export default protocol;
export { protocol, QywxProtocol, WxProtocol, DingTalkProtocol, FsProtocol };